/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SecurityPasswordInputIcon32Regular = forwardRef('SecurityPasswordInputIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M9.5 16A1.75 1.75 0 1 1 6 16a1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M13.25 17.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { d: "M20.5 16a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z" }),
        React.createElement("path", { d: "M24.25 17.75a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 11.5A5.5 5.5 0 0 1 6.5 6h19a5.5 5.5 0 0 1 5.5 5.5v9a5.5 5.5 0 0 1-5.5 5.5h-19A5.5 5.5 0 0 1 1 20.5v-9ZM6.5 8A3.5 3.5 0 0 0 3 11.5v9A3.5 3.5 0 0 0 6.5 24h19a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 25.5 8h-19Z" })));
});
